module.exports = __webpack_public_path__ + "static/media/bouwjaar.808fa203.jpg";